import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Provider } from "react-redux";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { store } from "./store";

/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;

const title = "Unity";
const container = document.getElementById("container");
const root = ReactDOM.createRoot(container);

const render = () => {
  root.render(
    <Provider store={store}>
      <AppContainer>
        <App title={title} isOfficeInitialized={isOfficeInitialized} />
      </AppContainer>
    </Provider>
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render();
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    render();
  });
}
